export function calculateDiffDays(value ){
	var present_date = new Date();    
	var date1 = new Date(value);
	
	// To calculate the time difference of two dates
	var Difference_In_Time =  date1.getTime() - present_date.getTime();
   
	// To calculate the no. of days between two dates
	return  ((Difference_In_Time / (1000 * 3600 * 24)).toFixed());    

}
export function formatDate(value, withTime = false) {
	if(value === undefined || value === null){
		return "/";
	}

	value = value.replace(/-/g, "/"); // resolve IE compatibility issue
	let date = new Date(value);

	if (validDate(date) === false) {
		return "/";
	}

	let d = date.getDate();
	let m = date.getMonth() + 1;
	let y = date.getFullYear();
	
	if (withTime === false) {
		return (d <= 9 ? "0" + d : d) + "." + (m <= 9 ? "0" + m : m) + "." + y;
	}

	let h = date.getHours();
	let min = date.getMinutes();
	return (
		(d <= 9 ? "0" + d : d) +
		"." +
		(m <= 9 ? "0" + m : m) +
		"." +
		y +
		" " +
		(h <= 9 ? "0" + h : h) +
		":" +
		(min <= 9 ? "0" + min : min)
	);
}
export function addOneYear(dateString) {
	const date = new Date(dateString);
	date.setFullYear(date.getFullYear() + 1);
	const year = date.getFullYear();
	const month = (date.getMonth() + 1).toString().padStart(2, '0');
	const day = date.getDate().toString().padStart(2, '0');
	return `${year}-${month}-${day} ${dateString.substring(11)}`;
}
export function validDate(date) {
	return date instanceof Date && !isNaN(date);
}

export function formatNumber(number){
	if(number === null){
		return '';
	}
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
	timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	}
}

export function getAvailablePoints(points = []) {
	return points.reduce((available, point) => {
		const currentDate = new Date();
		const givenDate = new Date(point.expiration);
		if (givenDate > currentDate) {
			return available + (point.negative !== -1 ? 1 : -1) * point.points;
		}
		return available;
	}, 0);
}

export function selectSurveyIcon(name){
	const icons = [
	'finance',
	'domu_in_duzini',
	'mediji',
	'mobilnost',
	'politika',
	'potrosnja',
	'telekomunikacije',
	'zaposlitvi',
	'zdravje',
	'zivljenjski_slog',
	'osebno',
	'delo'
	];
	
	const iconName = name.toLowerCase();

	const index = icons.findIndex(element => {
		if (iconName.includes(element)) {
			return true;
		}
		return false;
	})

	if(index < 0){
		return require(`@/assets/images/survey-icons/mobilnost.svg`)
	}

	const iconItem = icons[index];
	
	return require(`@/assets/images/survey-icons/${iconItem}.svg`)
}